module.exports = __webpack_public_path__ + "img/torsten.1a4c684c.jpg";